/** Hub-vs-Rasa silent comparison view helpers (Quality tab, spec infrastructure 2026-10-07-intent-shadow-comparison). */
export type ShadowClass = 'same' | 'hub_general' | 'differ' | 'hub_miss' | 'hub_extra' | 'both_none';

export const SHADOW_CLASSES: ShadowClass[] = ['same', 'hub_general', 'differ', 'hub_miss', 'hub_extra', 'both_none'];

export const CLASS_TEXT: Record<ShadowClass, string> = {
  same: 'Same intent',
  hub_general: 'Hub: general reply (thanks, greeting…)',
  differ: 'Different intents',
  hub_miss: 'Only Rasa found an intent',
  hub_extra: 'Only hub found an intent',
  both_none: 'Neither found an intent',
};

export const CLASS_TONE: Record<ShadowClass, string> = {
  same: 'bg-green-500',
  hub_general: 'bg-blue-400',
  differ: 'bg-red-500',
  hub_miss: 'bg-amber-500',
  hub_extra: 'bg-purple-400',
  both_none: 'bg-gray-300',
};

export function shareRows(counts: Record<ShadowClass, number>): { cls: ShadowClass; n: number; pct: number }[] {
  const total = SHADOW_CLASSES.reduce((a, c) => a + (counts[c] ?? 0), 0);
  return SHADOW_CLASSES.map((cls) => {
    const n = counts[cls] ?? 0;
    return { cls, n, pct: total ? Math.round((n / total) * 100) : 0 };
  });
}

const MIN_JUDGE = 50;
const MIN_READY = 200;
const AGREE_BAR = 0.9;

/** Suggested bar only — the owner decides the flip to live. Hub's general replies count as agreement. */
export function readinessNote(
  n: number,
  counts: Record<ShadowClass, number>,
): { tone: 'gray' | 'amber' | 'green'; text: string } {
  if (n < MIN_JUDGE) return { tone: 'gray', text: `Too few to judge (${n})` };
  const agree = ((counts.same ?? 0) + (counts.hub_general ?? 0)) / n;
  const pct = Math.floor(agree * 100);
  if (agree >= AGREE_BAR && n >= MIN_READY) return { tone: 'green', text: `Meets the suggested bar (${pct}% agree, n=${n})` };
  return {
    tone: 'amber',
    text: `Below the suggested bar (${pct}% agree, n=${n}; want ≥${AGREE_BAR * 100}% over ≥${MIN_READY})`,
  };
}
